import React from 'react';
import RegistrationSection from './RegistrationSection';
import { CommunityProvier } from 'features/community/presentation/provider/community.provider';
import { CommunityForm } from 'common/presentation/components';

const RegisrationPage = () => (
	<main>
		<CommunityProvier>
			<RegistrationSection />
			<CommunityForm />
		</CommunityProvier>
	</main>
);

export default RegisrationPage;
